import { dateFormatter } from '../../local_modules/voy-timeseries-chart/src/echarts-options';
import { UiStateModel, UiStateModelParam } from '../models/ui-state-model';
import { WhaleZonesModel } from '../models/whale-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { WhaleZonesLayerBase } from './whale-zones-layer-base';

export class ShoreWhaleZonesLayerInForce extends WhaleZonesLayerBase {
    connectEventHandlers(): void {
        UiStateModel!.addEventListener(`${UiStateModelParam.SelectedMapLayer}-change`, () => this.plotWhaleZones());
    }
    
    async getZones(): Promise<ZoneFeature[] | null> {
        let zones: ZoneFeature[] | null = null;
        const now = new Date();
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        zones = await WhaleZonesModel!.allActiveZones(now, tomorrow);

        return zones ? zones : [];
    }
} 
